import { useEffect, useRef } from "react";
import { usePhaseCountdown } from "./usePhaseCountdown";

/**
 * When the phase timer hits zero, fire `onTimeout` once (if not already submitted).
 * Returns the live countdown so UI can show the clock.
 */
export function useAutoSubmitOnTimeout(
  phaseEndsAt: number | undefined | null,
  youSubmitted: boolean,
  onTimeout: () => void,
) {
  const countdown = usePhaseCountdown(phaseEndsAt);
  const firedRef = useRef(false);
  const onTimeoutRef = useRef(onTimeout);
  onTimeoutRef.current = onTimeout;

  // Reset fire latch when a new deadline starts.
  useEffect(() => {
    firedRef.current = false;
  }, [phaseEndsAt]);

  useEffect(() => {
    if (youSubmitted) return;
    if (!countdown.active || !countdown.expired) return;
    if (firedRef.current) return;
    firedRef.current = true;
    onTimeoutRef.current();
  }, [countdown.active, countdown.expired, youSubmitted]);

  return countdown;
}
